import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AdminLogin from "./components/Admin/Login";
import PrivateRoute from "./components/PrivateRoute";
import StudentLogin from "./components/Student/Login";
import StudentRegister from "./components/Student/Register";
import Dashboard from "./pages/admin/Dashboard";
import LeaderBoard from "./pages/student/leaderboard";
import Player from "./pages/student/Player";
import Quiz from "./pages/student/Quiz";
import VideosPage from "./pages/admin/VideosPage";
import AssignmentPage from "./pages/admin/AssignmentPage";
import QuizPage from "./pages/admin/QuizPage";
import AssignmentMarkPage from "./pages/admin/AssignmentMarkPage";
import { userType } from "./config/userType";
import AddVideo from "./pages/admin/VideosPage/AddVideo";
import EditVideo from "./pages/admin/VideosPage/EditVideo";
import AddAssignment from "./pages/admin/AssignmentPage/AddAssignment";
import EditAssignment from "./pages/admin/AssignmentPage/EditAssignment";
import AddQuiz from "./pages/admin/QuizPage/AddQuiz";
import routes from "./config/routeConfig";
import EditQuiz from "./pages/admin/QuizPage/EditQuiz";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path={routes.index} element={<StudentLogin />} />
          <Route path={routes.student.register} element={<StudentRegister />} />
          <Route
            path={routes.student.leaderboard}
            element={
              <PrivateRoute>
                <LeaderBoard />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.student.coursePlayer}
            element={
              <PrivateRoute>
                <Player />
              </PrivateRoute>
            }
          />

          <Route
            path={routes.student.quiz()}
            element={
              <PrivateRoute>
                <Quiz />
              </PrivateRoute>
            }
          />

          <Route path={routes.admin.login} element={<AdminLogin />} />
          <Route
            path={routes.admin.dashboard}
            element={
              <PrivateRoute role={userType[0]}>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.videos}
            element={
              <PrivateRoute role={userType[0]}>
                <VideosPage />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.addVideo}
            element={
              <PrivateRoute role={userType[0]}>
                <AddVideo />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.editVideo()}
            element={
              <PrivateRoute role={userType[0]}>
                <EditVideo />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.assignments}
            element={
              <PrivateRoute role={userType[0]}>
                <AssignmentPage />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.addAssignment}
            element={
              <PrivateRoute role={userType[0]}>
                <AddAssignment />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.editAssignment()}
            element={
              <PrivateRoute role={userType[0]}>
                <EditAssignment />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.quiz}
            element={
              <PrivateRoute role={userType[0]}>
                <QuizPage />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.addQuiz}
            element={
              <PrivateRoute role={userType[0]}>
                <AddQuiz />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.editQuiz()}
            element={
              <PrivateRoute role={userType[0]}>
                <EditQuiz />
              </PrivateRoute>
            }
          />
          <Route
            path={routes.admin.assignmentMark}
            element={
              <PrivateRoute role={userType[0]}>
                <AssignmentMarkPage />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to={routes.redirect} />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
